export default __webpack_public_path__ + "static/media/4.f8079ae2.png";